module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.LeftMenuId
    }
  }, [_c('row-grid-menu', _vm._l((_vm.items), function(item, index) {
    return _c('menu-item', {
      key: item.icon,
      attrs: {
        "slot": item.slot,
        "track-by": "item.icon",
        "labelStyle": {
          size: '11',
          color: 'black'
        },
        "closePanel": _vm.closeOnClick,
        "link": item.link,
        "icon": item.icon,
        "label": item.label,
        "showNumberBadge": item.showNumberBadge,
        "emit": item.emit,
        "active": item.active,
        "backGroundColor": item.backGroundColor,
        "disabled": (_vm.userIsGuest() && item.guestActive !== '1') ||
          !_vm.$engine.user.validateAccess(item.right)
      },
      slot: item.slot,
      model: {
        value: (_vm.items[index]),
        callback: function($$v) {
          _vm.$set(_vm.items, index, $$v)
        },
        expression: "items[index]"
      }
    })
  }), 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5781b7e0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5781b7e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/leftPanel/servicesMenu.vue
// module id = 1674
// module chunks = 2